import React, {useState, useEffect} from "react";
import {connect} from "react-redux"
import {Spinner} from "react-bootstrap";
import Styles from "./Products.scss";
import NumberFormat from 'react-number-format';


const Product = (props)=>{

    const [asData, setAsData] = useState(false)
    const [product, setProduct] = useState()
    const [total, setTotal] = useState(1)
    const [priceTotal, setPriceTotal] = useState(1)


    useEffect(()=>{

    }, [])


    useEffect(()=>{
        setProduct(props.item)
    }, [props.item])

    useEffect(()=>{
        setPriceTotal((props.item.price)?Number(props.item.price):0)
    }, [props.item.price])

    useEffect(()=>{
        setPriceTotal(props.item.price*total)
    }, [total])

    useEffect(()=>{
    }, [priceTotal])

    const handleAmountChange=(action, amount)=>{

        if(action=='remove') {
            setTotal((total > 1) ? total - amount : 1)
        }else if(action=='pack'){
            setTotal(amount)
        }else{
            setTotal(total+amount)
        }
    }

    return (
        <div className={" mb-3"}>
                {
                    (product) ?
                        <div className={"d-flex flex-column flex-md-row h-100"}>
                            <div className="d-flex  flex-column p-2 m-1" style={{"backgroundColor":"var(--theme-page-background)", "color": "var(--theme-page-color)", "width":"100%"}}>
                                <img className={"shadow m-3 mb-2 p-2 bg-white rounded img-fluid align-self-center"} style={{"maxWidth":"370px"}} src={product.image} alt={product.name} />
                                <a href={product.sample} className={'btn btn-outline-primary btn-xs align-self-center'}>Example</a>
                            </div>
                            <div className="d-flex flex-column m-1" style={{"backgroundColor":"var(--theme-page-background)", "color": "var(--theme-page-color)", "lineHeight": "1.1rem"}}>
                                <div className="row">
                                    <div className="col  d-md-none border-top"></div>
                                </div>
                                <div className="p-2">
                                <div  dangerouslySetInnerHTML={{__html:product.description}}></div>
                                </div>
                            </div>
                        </div>
                        :<div className="text-center my-2"><Spinner animation="border" variant={"primary"} size={'sm'}/></div>
                }

        </div>
    )
}

const mapStateToProps = state => {
    return {
        userId: state.MeReducer.id,
    }
}

const mapDispatchTProps = dispatch => {
    return {
        addToCart: (e, b, c) => dispatch( {type: 'ADD_TO_CART', data:{product: e, quantity: b , totHT: c}}),
    }
}


export default connect(mapStateToProps, mapDispatchTProps)(Product);





